module.exports = __webpack_public_path__ + "static-v-shop/1792366500284/img/logo_maestro.ced7dab5.png";